export const RELEVANTE = "relevante";
export const HEADER = "header";
export const PUBLICIDAD = "publicidad";
export const LA_CAJA = "lacaja";
export const BLOG = "blog";
export const MIS_VIDEOS = "plokijuhygtfrdeswaq";
export const MIS_VIDEOS_CINE = "asdfghjkl";
